import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import {useRedux} from "../../../hooks";
import {Label, Row,} from 'reactstrap';

import InputText from "../../../components/InputText";

import '../../../i18/config';
import {useTranslation} from "react-i18next";

import {
    Formik,
    Form,
    Field
} from 'formik';
import {MainUserResetType} from "../../../redux/Main/User/types";
import {MainUserReset} from "../../../redux/Main/User/reducer";
import {onSendResetUser, setResetStatus} from "../../../redux/Main/User/actions";
import {ResetFormValidatorSchema} from "./ResetFormValidator";
import { GET_CSRF_TOKEN } from "../../../api/urls";
import { APIClient, setCSRFToken } from "../../../api/apiCore";

const ResetForm = () => {

    const { t } = useTranslation(['user','validator']);

    const { dispatch, useAppSelector } = useRedux();
    const [disabled, setDisabled] = useState<boolean>(false);

    useEffect(() => {
        const api = new APIClient();
        api.get(GET_CSRF_TOKEN).then((res: any) => {
            if (res && res.csrf_token) {
                setCSRFToken(res.csrf_token);
            }
        }).catch(() => {});
    }, []);

    const {
        currentUser,
        confirmationToken
    } = useAppSelector(state => ({
        currentUser: state.MainUser,
        confirmationToken: state.MainUser.confirmation.token
    }));

    const [formValues, setFormValues] = useState<MainUserResetType>(MainUserReset);
    const formikObject = useRef(null);

    useEffect(() => {
        if (confirmationToken !== undefined && confirmationToken !== null && confirmationToken.length>0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmationToken]);

    useEffect(() => {
        if (currentUser !== undefined && currentUser.isSendReset !== undefined) {
            setDisabled(currentUser.isSendReset);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser?.isSendReset]);

    const onDataSubmit = (formData:MainUserResetType) => {
        let data: any = {};

        dispatch(setResetStatus(true));

        if (formData.email) {
            data["email"] = formData.email;
        }

        let params: MainUserResetType = {
            email: data.email && data.email,
        };

        dispatch(onSendResetUser(params));
    };


    return (
        <>
            <div className={(confirmationToken !== undefined && confirmationToken !== null)?'visually-hidden':''}>
                <Formik
                    enableReinitialize={true}
                    initialValues={formValues}
                    validationSchema={ResetFormValidatorSchema}
                    onSubmit={(values, actions) => {
                        onDataSubmit(values);
                        actions.setSubmitting(false);
                    }}
                    innerRef={formikObject}
                >
                    {({errors, touched, setFieldValue, getFieldProps, isSubmitting, isValidating}) => (
                        <Form noValidate={true} className="customValidation">
                            <Row>
                                <div className={"mb-3" + (touched.email ? " was-validated" : '')}>
                                    <Label className="form-label" htmlFor="form-email-input">E-mail</Label>
                                    <Field
                                        id="form-email-input"
                                        name="email"
                                        placeholder={t('user:enterEmail')}
                                        component={InputText}
                                        value={getFieldProps('email').value}
                                        onChange={(value: string) => {
                                            setFieldValue('email', value);
                                        }}
                                        className={errors.email && touched.email && 'form-control is-invalid'}
                                    />
                                    {errors.email && touched.email ? (
                                        <div className="invalid-feedback">
                                            {t('validator:' + errors.email)}
                                        </div>
                                    ) : touched.email && !errors.email ?
                                        <div className="valid-feedback">
                                            {t('common:looksGood')}
                                        </div>
                                        : ''
                                    }
                                </div>
                            </Row>

                            <div className="mt-4">
                                <Button
                                    type="submit"
                                    disabled={disabled}
                                    color="success"
                                    className="w-100 btn-success">{t('auth:sendConfirmationCode')}</Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
</>
)
    ;
}

export default ResetForm;